import './index.scss'
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../Header'
import Footer from '../Footer'
import { CookieConsentBanner } from '..'
import { useStaticQuery, graphql } from 'gatsby'

const Layout = ({ children, color, margin }) => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://chatbot.holzweg.tv/embed/chatbot'
    script.async = true
    document.body.appendChild(script)
  }, [])

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          siteUrl
        }
      }
    }
  `)

  const schemaMarkup = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'holzweg GmbH',
    url: data.site.siteMetadata.siteUrl,
    logo: 'https://www.holzweg.com/holzweg-logo/holzweglogo.jpg',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Adamgasse 11 / 3. Stock',
      addressLocality: 'Innsbruck',
      addressRegion: 'Tirol',
      postalCode: '6020',
      addressCountry: 'AT',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+43-699-17407403',
      contactType: 'customer service',
      email: 'office@holzweg.com',
    },
    sameAs: [
      'https://www.facebook.com/holzwegwebagentur',
      'https://www.linkedin.com/company/holzweg-e-commerce-solutions',
    ],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '5',
      reviewCount: '6',
    },
    review: [
      {
        '@type': 'Review',
        author: {
          '@type': 'Person',
          name: 'Mag. Anny Franzelin M.A.',
        },
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
          bestRating: '5',
        },
        reviewBody:
          'Die Zusammenarbeit mit den verschiedenen Teammitgliedern der Firma holzweg war zu jedem Projektzeitpunkt sehr angenehm und konstruktiv.',
        publisher: {
          '@type': 'Organization',
          name: 'Stadtmarketing Hall in Tirol',
        },
      },
      {
        '@type': 'Review',
        author: {
          '@type': 'Person',
          name: 'Roland Teißl',
        },
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
          bestRating: '5',
        },
        reviewBody:
          'Die Zusammenarbeit mit der Firma holzweg war stets konstruktiv und sehr angenehm. holzweg hat uns professionell unterstützt.',
        publisher: {
          '@type': 'Organization',
          name: 'Wirtschaftskammer Österreich / Tirol',
        },
      },
      {
        '@type': 'Review',
        author: {
          '@type': 'Person',
          name: 'Dr. Karin Bauer',
        },
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5',
          bestRating: '5',
        },
        reviewBody:
          'Innovative Ideen und kreative Lösungsvorschläge, begleitet von einer sehr angenehmen Zusammenarbeit.',
        publisher: {
          '@type': 'Organization',
          name: 'Diözese Innsbruck',
        },
      },
    ],
  }

  return (
    <>
      <Helmet>
        <html lang="de" />
        {/* Include the global structured data */}
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      </Helmet>
      <div
        className={`page-container ${margin ? 'page-container--no-header' : ''}`}
      >
        <Header color={color} />
        {children}
        <Footer />
      </div>
      <CookieConsentBanner />
      <chatbot-chat id="1fd386c0-1557-4b22-9814-3dc1560377ae" />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
